(function () {
  if (window.__sizeChartInit) return;
  window.__sizeChartInit = true;

  var activeModal = null;

  function openModal(modal) {
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('size-chart-open');
    activeModal = modal;
    var closeBtn = modal.querySelector('[data-size-chart-close]');
    if (closeBtn) closeBtn.focus();
  }

  function closeModal(modal) {
    if (!modal) return;
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('size-chart-open');
    if (activeModal === modal) activeModal = null;
  }

  function setUnit(modal, unit) {
    modal.querySelectorAll('[data-size-chart-unit]').forEach(function (btn) {
      var isActive = btn.getAttribute('data-size-chart-unit') === unit;
      btn.classList.toggle('is-active', isActive);
      btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });
    modal.querySelectorAll('[data-cm]').forEach(function (cell) {
      cell.textContent = cell.getAttribute('data-' + unit);
    });
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-size-chart-open]');
    if (opener) {
      e.preventDefault();
      var id = opener.getAttribute('data-size-chart-open');
      var modal = document.getElementById(id);
      if (modal) openModal(modal);
      return;
    }

    var closer = e.target.closest('[data-size-chart-close]');
    if (closer) {
      e.preventDefault();
      var modal = closer.closest('[data-size-chart-modal]');
      closeModal(modal);
      return;
    }

    var unitBtn = e.target.closest('[data-size-chart-unit]');
    if (unitBtn) {
      var modal = unitBtn.closest('[data-size-chart-modal]');
      if (modal) setUnit(modal, unitBtn.getAttribute('data-size-chart-unit'));
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && activeModal) closeModal(activeModal);
  });
})();
